import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        survey: null,
        entry: null,
        nextQuestionID: null,
        resultID: null,
        appType: ''
    },
    mutations: {
        setSurvey: function (state, payload) {
            state.survey = payload.survey;
        },
        setEntry: function (state, payload) {
            state.entry = payload.entry;
        },
        setNextQuestionID: function (state, payload) {
            state.nextQuestionID = payload.nextQuestionID;
        },
        setResultID: function (state, payload) {
            state.resultID = payload.resultID;
        },
        setAppType: function (state, appType) {
            state.appType = appType;
        }
    }
});
